($ => {
  $('.page_item_has_children').click(function (e) {
    e.stopPropagation();
    $(this).toggleClass('is-open');
  });

  $('.page_item_has_children a').click(e => {
    e.stopPropagation();
  });
})(jQuery);
